var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#898989;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye-other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,421C147.78,421,49.91,358.72.58,258.51a5.7,5.7,0,0,1,0-5C49.91,153.28,147.78,91,256,91s206.09,62.26,255.42,162.47a5.7,5.7,0,0,1,0,5C462.09,358.72,364.22,421,256,421ZM12,256c47.78,94.82,141,153.6,244,153.6S452.17,350.82,500,256c-47.78-94.82-141-153.6-244-153.6S59.83,161.18,12,256Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,352.71A96.71,96.71,0,1,1,352.71,256,96.82,96.82,0,0,1,256,352.71Zm0-182A85.33,85.33,0,1,0,341.33,256,85.43,85.43,0,0,0,256,170.67Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.40937717e5e7c6393e2fef878792536d.svg";
export { ForwardRef as ReactComponent };